import dayjs from 'dayjs'

export default function format(date: number | string | Date, format: string) {
  return dayjs(date).format(format)
}
